import { useEffect } from "react";

function isTypingTarget(t) {
  return t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable);
}

// Scorciatoie: "/" focus ricerca nominativi, frecce sx/dx cambio giorno
export function usePlannerShortcuts(monthInfo, setDay) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "/" && !isTypingTarget(e.target)) {
        e.preventDefault();
        document.querySelector('[data-testid="personnel-search-input"]')?.focus();
        return;
      }
      if (isTypingTarget(e.target) || !monthInfo) return;
      if (e.key === "ArrowRight") setDay((d) => Math.min(d + 1, monthInfo.days.length));
      else if (e.key === "ArrowLeft") setDay((d) => Math.max(d - 1, 1));
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // monthInfo/setDay sono le uniche deps reali; e/d sono parametri e locali delle callback
  }, [monthInfo, setDay]); // eslint-disable-line react-hooks/exhaustive-deps
}
